module.exports = __webpack_public_path__ + "img/thumb_up_blue.7087f06a.svg";